import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import API from './api';

const CategoryContext = createContext({ categories: [], loading: true, refetch: () => {} });

const CACHE_KEY = 'lc_categories_cache_v1';
const CACHE_TTL = 10 * 60 * 1000; // 10 minutes

export const CategoryProvider = ({ children }) => {
  const [categories, setCategories] = useState(() => {
    // Hydrate from sessionStorage so navigation between pages is INSTANT
    try {
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        const { data, ts } = JSON.parse(cached);
        if (Date.now() - ts < CACHE_TTL && Array.isArray(data)) return data;
      }
    } catch (e) {}
    return [];
  });
  const [loading, setLoading] = useState(categories.length === 0);

  const fetchCategories = useCallback(() => {
    API.get('/gigs/categories/')
      .then(res => {
        const data = res.data?.results || res.data || [];
        setCategories(data);
        try {
          sessionStorage.setItem(CACHE_KEY, JSON.stringify({ data, ts: Date.now() }));
        } catch (e) {}
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (categories.length === 0) fetchCategories();
  }, [categories.length, fetchCategories]);

  return (
    <CategoryContext.Provider value={{ categories, loading, refetch: fetchCategories }}>
      {children}
    </CategoryContext.Provider>
  );
};

export const useCategories = () => useContext(CategoryContext);
export default CategoryContext;
